import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $CurrentUserOrNull } from '@user/shared/current-user';
import { UserTwitter } from './twitter';
import { UserOG } from './og';
import { UserFacebook } from './facebook';
import { UserTDK } from '@user/head/tdk';
import { FallbackPageHelmet } from '~/components/fallback-page-helmet';

export const UserHead: FC = () => {
  const user = useAtomValue($CurrentUserOrNull);

  if (user) {
    return (
      <>
        <UserTDK />
        <UserFacebook />
        <UserOG />
        <UserTwitter />
      </>
    );
  }

  return <FallbackPageHelmet />;
};
